module.exports = __webpack_public_path__ + "static/media/blocked.61d71a85.svg";